import React from "react";
import {
  RiCellphoneFill,
  RiFacebookCircleFill,
  RiMailFill,
  RiPhoneFill,
  RiWhatsappFill,
} from "react-icons/ri";
import { Link } from "react-router-dom";

const SocialBar = () => {
  return (
    <div className="h-screenx top-1/2 -translate-y-20  fixed  right-2 lg:right-6 xl:right-20 z-20 flex flex-col items-center justify-center">
      <div className="w-full flex flex-col items-end">
        <div className="flex flex-col items-center justify-center gap-4 px-2 py-4 text-2xl bg-_dark rounded-full text-_white font-bold shadow-lg">
          <button className=" group">
            <RiWhatsappFill />
            <p className=" hidden group-hover:block absolute text-nowrap right-12  -translate-y-7 text-base border border-_dark_lite p-3 rounded-md backdrop-blur-md shadow-lg bg-_dark bg-opacity-40">
              Whatsapp
            </p>
          </button>
          <a href={"https://www.facebook.com/share/1WjFsUZKEv/"} target="_blank">
          <button className=" group">
            <RiFacebookCircleFill />

            <p className=" hidden group-hover:block absolute text-nowrap right-12  -translate-y-7 text-base border border-_dark_lite p-3 rounded-md backdrop-blur-md shadow-lg bg-_dark bg-opacity-40">
              Follow us on facebook
            </p>
          </button>
          </a>
          <a href={"mailto:medtools.lk@gmail.com"} target="_blank">
          <button className=" group">
            <RiMailFill />
            <p className=" hidden group-hover:block absolute text-nowrap right-12  -translate-y-7 text-base border border-_dark_lite p-3 rounded-md backdrop-blur-md shadow-lg bg-_dark bg-opacity-40">
              medtools.lk@gmail.com
            </p>
          </button>
          </a>

          <a href={"tel:0783700701"} target="_blank">
          <button className=" group">
            <RiPhoneFill />
            <div className=" hidden group-hover:block absolute text-nowrap right-12  -translate-y-7 text-base border border-_dark_lite p-3 rounded-md backdrop-blur-md shadow-lg bg-_dark bg-opacity-40">
              0783700701
            </div>
          </button>
          </a>

        </div>
      </div>
    </div>
  );
};

export default SocialBar;
